import { Analytics } from '../../views/ts/components/Analytics';
import { CookiesConsent } from '../../views/twig/components/CookiesConsent';
import { Carousel } from '../../views/ts/components/Carousel';
import { Collapse } from '../../views/ts/components/Collapse';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Menu } from '../../views/twig/components/Menu';
import { Home } from '../twig/modules/home';
import { Team } from '../twig/modules/team';
import { Agenda } from '../twig/components/Agenda';
import { ModuleMedia } from '../twig/modules/medias';
(new Analytics()).init();
(new Carousel()).init();
(new Collapse()).init();
(new LazyLoader()).init();
(new Menu()).init();
(new Home()).init();
(new Team()).init();
(new Agenda()).init();
(new ModuleMedia()).init();
// Always at the end
(new CookiesConsent()).init();
